import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-12 md:py-16 scroll-mt-32">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-8 lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs tracking-wide text-primary-700 bg-primary-50 border border-primary-200 px-2.5 py-1 rounded-full">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              关于内容与更新的说明
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们尽量把信息来源与判断标准讲清楚。如果你还有别的疑问，欢迎通过页面底部的表单联系我们。
            </p>
            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-4">
              <p className="text-xs text-foreground-600 leading-relaxed">
                <i className="ri-shield-check-line mr-1 text-accent-600"></i>
                本站不发布未经核实的匿名私信内容，涉及个人权益的表述均以公开信息为限。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 divide-y divide-background-200">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.q}>
                  <h3>
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenIndex(open ? null : index)}
                      className="w-full flex items-start gap-3 px-4 md:px-5 py-4 text-left hover:bg-primary-50 transition-colors cursor-pointer"
                    >
                      <span className={`mt-0.5 w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs ${open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                        {index + 1}
                      </span>
                      <span className="flex-1 text-sm md:text-base text-foreground-900 leading-snug">
                        {item.q}
                      </span>
                      <i
                        className={`mt-0.5 shrink-0 text-foreground-500 transition-transform ${open ? 'ri-subtract-line' : 'ri-add-line'}`}
                      ></i>
                    </button>
                  </h3>
                  {open && (
                    <div className="px-4 md:px-5 pb-4">
                      <p className="ml-9 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}